export default __webpack_public_path__ + "static/media/ls3_g04.4d144326.png";